export const classNames = (...names) => names.filter((x) => x).join(" ")

export const highlight = (text, highlightWord) => {
  const index = text.toLowerCase().indexOf(highlightWord.toLowerCase())
  return index >= 0
    ? text.substring(0, index) +
        "<span class='highlight'>" +
        text.substring(index, index + text.length) +
        "</span>" +
        text.substring(index + text.length)
    : text
}
